import { jsx as _jsx } from "react/jsx-runtime";
import { useTag } from "../core/hooks.js";
import error from "../core/utils/error.js";
export default function Image({ tag, classNames, element = "div", src, ...rest }) {
    if (!src || typeof src !== "string")
        error("Image component requires a src prop of type string. Make sure to provide a valid image URL.");
    const [img, imgRef] = useTag(tag, src, { type: "image" });
    const Container = element;
    return (_jsx(Container, { className: classNames?.container, ref: imgRef, children: _jsx("img", { className: classNames?.image, src: img, ...rest }) }));
}
